import { render } from "./CustomInputText.vue?vue&type=template&id=68b562b2&scoped=true"
import script from "./CustomInputText.vue?vue&type=script&lang=js"
export * from "./CustomInputText.vue?vue&type=script&lang=js"

import "./CustomInputText.vue?vue&type=style&index=0&id=68b562b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68b562b2"]])

export default __exports__